module.exports = "<uch></uch>\r\n<work-header params=\"current:'accountApply'\"></work-header> \r\n<div class=\"work_content\">\r\n    <div class=\"userContent\">\r\n        <account-apply></account-apply>\r\n    </div>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/component/workflow/accountApplyIndex.html
// module id = 197
// module chunks = 0